// material-ui
//import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *

 *
 */

//import logoDark from 'assets/images/logo-dark.svg';
//import logo from '';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  // const theme = useTheme();
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * 
     *
     */
    <>
    <img src="/images/logo.png" alt="Deliverit Logo" width="50" />
    </>
  );
}
